<nav>
  <div class="logo-breadcrumbs">
    <div
      class="hamburger"
      (click)="onClickHamburger()"
    >
      <i class="fa-solid fa-bars"></i>
    </div>

    <a
      class="logo"
      routerLink="/"
    >
      <svg
        width="100px"
        height="50px"
        viewBox="0 0 495 151"
      >
        <title>Motion logo</title>
        <path
          d="M448.94402,0 L431,151 L0,151 L17.9440202,0 L448.94402,0 Z M168.532813,67.5859375 C157.845313,67.5859375 148.939063,71.0078125 141.814063,77.8515625 C134.735938,84.6484375 131.196875,93.1796875 131.196875,103.445312 C131.196875,113.476562 134.61875,121.773438 141.4625,128.335938 C148.259375,134.851562 157.025,138.109375 167.759375,138.109375 C178.025,138.109375 186.65,134.664062 193.634375,127.773438 C200.665625,120.882812 204.18125,112.375 204.18125,102.25 C204.18125,91.984375 200.853125,83.6640625 194.196875,77.2890625 C187.5875,70.8203125 179.032813,67.5859375 168.532813,67.5859375 Z M310.232813,67.5859375 C299.545313,67.5859375 290.639063,71.0078125 283.514063,77.8515625 C276.435938,84.6484375 272.896875,93.1796875 272.896875,103.445312 C272.896875,113.476562 276.31875,121.773438 283.1625,128.335938 C289.959375,134.851562 298.725,138.109375 309.459375,138.109375 C319.725,138.109375 328.35,134.664062 335.334375,127.773438 C342.365625,120.882812 345.88125,112.375 345.88125,102.25 C345.88125,91.984375 342.553125,83.6640625 335.896875,77.2890625 C329.2875,70.8203125 320.732813,67.5859375 310.232813,67.5859375 Z M69.0234375,68.078125 C62.2894176,68.078125 56.338847,70.5851627 51.1717257,75.5992381 L50.8125,75.953125 L51.515625,69.765625 L35.484375,69.765625 L27.328125,136 L42.8671875,136 L47.4375,99.0859375 C48.890625,87.1328125 53.9296875,81.15625 62.5546875,81.15625 C68.5078125,81.15625 71.484375,83.8984375 71.484375,89.3828125 C71.484375,90.6428125 71.289975,92.9396125 70.901175,96.2732125 L70.8515625,96.6953125 L66,136 L81.5390625,136 L86.0390625,99.015625 C86.4609375,95.875 87.0585938,93.1679688 87.8320312,90.8945312 C88.6054688,88.6210938 89.5898438,86.7695312 90.7851562,85.3398438 C91.9804688,83.9101562 93.421875,82.8554688 95.109375,82.1757812 C96.796875,81.4960938 98.7890625,81.15625 101.085938,81.15625 C106.898438,81.15625 109.804688,84.0390625 109.804688,89.8046875 C109.804688,91.415483 109.61249,93.8804881 109.228096,97.199703 L109.171875,97.6796875 L104.390625,136 L119.929688,136 L124.429688,99.5078125 C124.804688,96.2734375 125.097656,93.5546875 125.308594,91.3515625 C125.519531,89.1484375 125.625,87.4375 125.625,86.21875 C125.625,74.171875 119.0625,68.1484375 105.9375,68.1484375 C98.34375,68.1484375 91.265625,71.640625 84.703125,78.625 C82.921875,74.59375 80.90625,71.8515625 78.65625,70.3984375 C76.40625,68.8515625 73.1953125,68.078125 69.0234375,68.078125 Z M237.05,39.0390625 L221.510938,39.0390625 L217.714063,69.765625 L208.925,69.765625 L207.167188,84.1796875 L215.95625,84.1796875 L209.557813,136 L225.096875,136 L231.495312,84.1796875 L245.839062,84.1796875 L247.596875,69.765625 L233.253125,69.765625 L237.05,39.0390625 Z M268.785937,69.765625 L253.246875,69.765625 L245.090625,136 L260.629687,136 L268.785937,69.765625 Z M391.335938,68.1484375 C385.207889,68.1484375 379.146764,70.602334 373.152565,75.510127 L372.703125,75.8828125 L373.40625,69.765625 L357.9375,69.765625 L349.78125,136 L365.320312,136 L369.257812,104.078125 C369.585938,101.40625 369.960938,99.0507812 370.382812,97.0117188 C370.804688,94.9726562 371.320312,93.25 371.929688,91.84375 C373.054688,89.078125 374.789062,86.734375 377.132812,84.8125 C379.992188,82.375 383.414062,81.15625 387.398438,81.15625 C393.867188,81.15625 397.101562,84.15625 397.101562,90.15625 C397.101562,91.046875 397.066406,92.0546875 396.996094,93.1796875 C396.93457,94.1640625 396.828186,95.2740479 396.676941,96.5096436 L396.609375,97.046875 L391.828125,136 L407.296875,136 L411.726562,100.421875 C412.289062,95.734375 412.570312,91.703125 412.570312,88.328125 C412.570312,82.09375 410.671875,77.171875 406.875,73.5625 C402.984375,69.953125 397.804688,68.1484375 391.335938,68.1484375 Z M168.392188,80.59375 C174.392188,80.59375 179.24375,82.515625 182.946875,86.359375 C186.65,90.0625 188.501563,95.1015625 188.501563,101.476562 C188.501563,108.414062 186.509375,114.085938 182.525,118.492188 C178.5875,122.945312 173.571875,125.171875 167.478125,125.171875 C161.384375,125.171875 156.415625,123.132812 152.571875,119.054688 C148.728125,115.070312 146.80625,109.796875 146.80625,103.234375 C146.80625,96.71875 148.845313,91.3046875 152.923438,86.9921875 C157.001563,82.7265625 162.157813,80.59375 168.392188,80.59375 Z M310.092188,80.59375 C316.092188,80.59375 320.94375,82.515625 324.646875,86.359375 C328.35,90.0625 330.201563,95.1015625 330.201563,101.476562 C330.201563,108.414062 328.209375,114.085938 324.225,118.492188 C320.2875,122.945312 315.271875,125.171875 309.178125,125.171875 C303.084375,125.171875 298.115625,123.132812 294.271875,119.054688 C290.428125,115.070312 288.50625,109.796875 288.50625,103.234375 C288.50625,96.71875 290.545313,91.3046875 294.623438,86.9921875 C298.701563,82.7265625 303.857813,80.59375 310.092188,80.59375 Z"
          id="Combined-Shape"
        ></path>
        <path
          d="M479.579545,37.2244318 C481.387311,37.2244318 483.080729,36.8868371 484.659801,36.2116477 C486.238873,35.5364583 487.627367,34.5999053 488.825284,33.4019886 C490.023201,32.204072 490.959754,30.8155777 491.634943,29.2365057 C492.310133,27.6574337 492.647727,25.9640152 492.647727,24.15625 C492.647727,22.3484848 492.310133,20.6550663 491.634943,19.0759943 C490.959754,17.4969223 490.023201,16.108428 488.825284,14.9105114 C487.627367,13.7125947 486.238873,12.7760417 484.659801,12.1008523 C483.080729,11.4256629 481.387311,11.0880682 479.579545,11.0880682 C477.77178,11.0880682 476.078362,11.4256629 474.49929,12.1008523 C472.920218,12.7760417 471.531723,13.7125947 470.333807,14.9105114 C469.13589,16.108428 468.199337,17.4969223 467.524148,19.0759943 C466.848958,20.6550663 466.511364,22.3484848 466.511364,24.15625 C466.511364,25.9640152 466.848958,27.6574337 467.524148,29.2365057 C468.199337,30.8155777 469.13589,32.204072 470.333807,33.4019886 C471.531723,34.5999053 472.920218,35.5364583 474.49929,36.2116477 C476.078362,36.8868371 477.77178,37.2244318 479.579545,37.2244318 Z M479.579545,34.0880682 C477.75,34.0880682 476.083807,33.641572 474.580966,32.7485795 C473.078125,31.8555871 471.880208,30.6576705 470.987216,29.1548295 C470.094223,27.6519886 469.647727,25.9857955 469.647727,24.15625 C469.647727,22.3267045 470.094223,20.6605114 470.987216,19.1576705 C471.880208,17.6548295 473.078125,16.4569129 474.580966,15.5639205 C476.083807,14.670928 477.75,14.2244318 479.579545,14.2244318 C481.409091,14.2244318 483.075284,14.670928 484.578125,15.5639205 C486.080966,16.4569129 487.278883,17.6548295 488.171875,19.1576705 C489.064867,20.6605114 489.511364,22.3267045 489.511364,24.15625 C489.511364,25.9857955 489.064867,27.6519886 488.171875,29.1548295 C487.278883,30.6576705 486.080966,31.8555871 484.578125,32.7485795 C483.075284,33.641572 481.409091,34.0880682 479.579545,34.0880682 Z M477.651989,30.0369318 L477.651,25.954 L480.276,25.954 L482.389205,30.0369318 L485.296875,30.0369318 L482.827,25.366 L482.848505,25.353954 C483.284962,25.089017 483.670882,24.7398515 484.006264,24.3064575 L484.169744,24.0827415 C484.59446,23.4674479 484.806818,22.71875 484.806818,21.8366477 C484.806818,20.9654356 484.602628,20.2439631 484.194247,19.6722301 C483.785866,19.1004972 483.293087,18.6757813 482.715909,18.3980824 C482.138731,18.1203835 481.605114,17.9815341 481.115057,17.9815341 L481.115057,17.9815341 L475.005682,17.9815341 L475.005682,30.0369318 L477.651989,30.0369318 Z M477.651989,19.9417614 L480.167614,19.9417614 C480.483428,19.9417614 480.850971,20.0724432 481.270241,20.3338068 C481.689512,20.5951705 481.899148,21.0961174 481.899148,21.8366477 C481.899148,22.5553977 481.689512,23.0944602 481.270241,23.4538352 C480.850971,23.8132102 480.461648,23.9928977 480.102273,23.9928977 L480.102273,23.9928977 L477.651,23.993 L477.651989,19.9417614 Z"
          id="®"
          fill-rule="nonzero"
        ></path>
      </svg>
    </a>

    <div class="breadcrumbs">
      @for (breadcrumb of breadcrumbs; track breadcrumb.text) {
        <a [routerLink]="breadcrumb.path ? [breadcrumb.path] : null">
          <i class="fa-solid fa-caret-right"></i>
          {{breadcrumb.text}}
          @if (breadcrumb.icon) {
            <i [ngClass]="'fa-solid fa-' + breadcrumb.icon"></i>
          }
        </a>
      }
    </div>
  </div>

  <div class="search-area">
    <div
      class="global-search"
      [class.disabled]="!searchEnabled"
      [class.panel-mode]="filtersConfig?.by?.tags"
      [class.panel-open]="filterPanelOpen"
    >
    @if (!filtersConfig?.by?.tags) {
      <div
        class="filter-icon"
        [class.active]="filters || filtersOpen"
        [class.disabled]="!filtersConfig"
        (click)="onUserClickedFiltersButton()"
      >
        <i class="fa-regular fa-filter-list"></i>

        @if (filtersOpen) {
          <motn-filters-menu
            [filtersConfig]="filtersConfig"
            (clickedOutsideMenu$)="filtersOpen = false"
          ></motn-filters-menu>
        }
      </div>
    }

    <div
      class="search-icon"
    >
      <i class="fa-regular fa-magnifying-glass"></i>
    </div>

    <input
      type="text"
      [placeholder]="searchPlaceholder"
      name="searchbox"
      [(ngModel)]=searchTerm
      aria-label="Search"
      (ngModelChange)="onUserChangedSearchTerm()"
      (focus)="searchFocused = true; onSearchFocused()"
      (blur)="searchFocused = false"
      autocomplete="off"
      spellcheck=false
      [disabled]="!searchEnabled"
      [class.panel-open]="filterPanelOpen"
      #searchbox
    >

    @if (searchTerm) {
      <div
        class="result-qty"
        (click)="onUserClearedSearchTerm()"
      >
        {{searchResultQty.toLocaleString()}} Search {{searchResultQty === 1 ? 'Match' : 'Matches'}}
      </div>
    }

    @if (filterPanelOpen && filtersConfig?.by?.tags) {
      <motn-tile-tag-filter-panel
        [filtersConfig]="filtersConfig"
        [searchInputRef]="searchBoxEl"
        (clickedOutside)="onFilterPanelClickedOutside()"
      ></motn-tile-tag-filter-panel>
    }
  </div>

  @if (filterPillItems.length) {
    <motn-pill-list
      class="filter-pills"
      [items]="filterPillListItems"
      [maxVisible]="maxVisiblePills"
      [removable]="true"
      [overlayPositions]="pillsOverlayPositions"
      (remove)="removeFilterPill($event)"
    ></motn-pill-list>
  }
  </div>
</nav>

<div class="app-title">
  <div
    class="left"
  >
    <div
      class="title"
    >
      @if (displayIcon) {
        <div [innerHTML]="'<i class=\'fa-regular fa-'+displayIcon+'\'>'"
        ></div>
      }

      {{displayTitle}}
    </div>

    <div class="pills">
      @if (displaySubtitle && displaySubtitle.length > 0) {
        @for (item of displaySubtitle; track item.text) {
          <motn-pill
            [class.clickable]="!!item.callback"
            (click)="item.callback && item.callback()"
          >
            @if (item.icon) {
              @if (item.icon.startsWith('kit:')) {
                <i [ngClass]="[
                  'fa-kit',
                  'fa-' + item.icon.substring(4)
                ]"></i>
              } @else {
                <i [ngClass]="[
                  'fa-regular',
                  'fa-' + item.icon
                ]"></i>
              }
            }
            {{item.text}}
          </motn-pill>
        }
      }

      @if (weatherLocation?.PostalCode) {
        <motn-pill>
          <motn-current-weather
            [postalCode]="weatherLocation.PostalCode"
          ></motn-current-weather>
        </motn-pill>
      }
    </div>
  </div>

  <div
    class="right"
  >

  </div>
</div>
